<template>
  <div>
    <b-alert
      :show="dismissCountDown"
      variant="success"
      dismissible
      @dismissed="dismissCountdown = 0"
      @dismiss-count-down="countDownChanged"
    >
      Prognose opgeslagen... {{ dismissCountDown }}
    </b-alert>
    
    <!-- New Responsive Header -->
    <div class="mb-3">
      <!-- <h6 class="text-muted mb-2">New Responsive Header:</h6> -->
      <prognose-header
        :inspectie="inspectie"
        :unit="unit"
        :prognoseid="prognoseid"
        :nog-te-checken="nogTeChecken"
        :on-update="updatePrognose"
        :on-delete="prognoseid == unit.HuidigePrognose ? warningHuidigePrognose : deletePrognose"
        :max-conditie-value.sync="maxConditieValue"
        :show-technische-data-info.sync="showTechnischeDataInfo"
        @show-transpose="transpose.showDialog = true"
      />
    </div>
    
    <!-- Original Header -->
    <!-- <div class="mb-3">
      <h6 class="text-muted mb-2">Original Header:</h6>
    <h6>
      <i 
        v-if="inspectie.isBevroren" 
        class="fa fa-lock"
      />
      {{ inspectie.omschrijving || unit.UnitKenmerk }} <small>op</small>
      {{ moment(inspectie.datum).format("LL") }} <small> door</small>
      {{ inspectie.inspecteur ? inspectie.inspecteur.naam : "Geen inspecteur" }}
      <b-badge 
        v-if="inspectie.isTemplate" 
        variant="info" 
        class="mx-1"
      >
        Template
      </b-badge>
      <b-badge 
        v-if="prognoseid == unit.HuidigePrognose" 
        variant="warning"
      >
        Dit is de huidige prognose!
      </b-badge>
      <b-badge 
        v-if="inspectie.gereed" 
        class="mx-2"
        variant="info"
      >
        <font-awesome-icon icon="check" /> Inspectie voltooid
      </b-badge>
    </h6>
    <b-button-toolbar class="mb-2">
      <opslaan-dialog
        :inspectie="inspectie"
        :unit="unit"
        :on-update="updatePrognose"
        :on-delete="
          prognoseid == unit.HuidigePrognose
            ? warningHuidigePrognose
            : deletePrognose
        "
      />

      <b-form-checkbox
        v-model="showTechnischeDataInfo"
        :button-variant="showTechnischeDataInfo ? 'primary' : 'outline-primary'"
        button
        class="mx-2"
      >
        <b-badge 
          v-if="nogTeChecken.length > 0" 
          variant="danger" 
          pill
        >
          {{
            nogTeChecken.length
          }}
        </b-badge>
        <i
          :class="['fa', showTechnischeDataInfo ? 'fa-outdent' : 'fa-indent']"
        />
      </b-form-checkbox>

      <template v-if="inspectie.inspectie.config">
        <b-form-checkbox
          v-model="inspectie.inspectie.config.showModeratorPanel"
          :button-variant="
            inspectie.inspectie.config.showModeratorPanel
              ? 'primary'
              : 'outline-primary'
          "
          button
        >
          <i class="fa fa-magnet" />
        </b-form-checkbox>

        <b-form-checkbox
          v-model="inspectie.inspectie.config.showHeaderRows"
          :button-variant="
            inspectie.inspectie.config.showHeaderRows
              ? 'primary'
              : 'outline-primary'
          "
          button
          class="mx-2"
        >
          <i class="fa fa-list" />
        </b-form-checkbox>

        <b-form-radio-group
          v-model="inspectie.inspectie.config.modus"
          :options="modi"
          buttons
          button-variant="outline-primary"
        />

        <b-button
          v-if="
            inspectie.inspectie.config &&
              inspectie.inspectie.config.modus == 'Positie'
          "
          class="ml-2"
          @click="
            inspectie.inspectie.onderdelen.push({ title: '', jaar: null })
          "
        >
          <i class="fa fa-plus" /> Element
        </b-button>

        <b-button 
          class="ml-2"
          variant="warning"
          @click="transpose.showDialog = true"
        >
          <font-awesome-icon 
            icon="arrows-alt-h"
          />
        </b-button>

        <b-input-group 
          class="mx-2" 
          prepend="Bouwjaar"
        >
          <b-input-group-addon>
            <b-input
              v-model="inspectie.inspectie.config.bouwjaar"
              :placeholder="unit.Bouwjaar.toString()"
              type="number"
              disabled
            />
          </b-input-group-addon>
        </b-input-group>

        <b-input-group 
          class="mx-2" 
          prepend="Jaar"
        >
          <b-input-group-addon>
            <b-input
              v-model.number="inspectie.inspectie.config.jaar"
              type="number"
            />
          </b-input-group-addon>
        </b-input-group>

        <b-input-group prepend="Jaren">
          <b-input-group-addon>
            <b-form-select
              v-model="inspectie.inspectie.config.jaren"
              :options="jarenOpties"
            />
          </b-input-group-addon>
        </b-input-group>

        <b-input-group 
          :prepend="`Conditie in  ${new Date().getFullYear() + (inspectie.inspectie.config.inclusief || 0)}`"
          class="mx-2"
        >
          <b-input 
            v-model.number="inspectie.inspectie.config.inclusief" 
            variant="dark"
            style="width:20em;"
            type="range"
            min="0" 
            max="10"
          />
          
          <conditie-limit
            v-model="maxConditieValue"
            label="Max conditie (acties)"
            :show-info="true"
            scope="global"
          />
        </b-input-group>
      </template>
    </b-button-toolbar>
    </div> End Original Header -->

    <b-row>
      <b-col 
        v-show="showTechnischeDataInfo" 
        md="3"
      >
        <b-tabs small>
          <b-tab 
            v-if="checklist.length" 
            title="Import"
          >
            <b-button
              :disabled="prognose == null"
              class="my-2"
              size="lg"
              block
              variant="primary"
              @click="startImport"
            >
              <i class="cui cui-cog" />
              Start import {{ importlijst.length }} onderdelen
            </b-button>

            <b-check
              v-if="checklist.length"
              v-model="skipChecklist"
              class="mb-4"
            >
              Checklist niet importeren!
            </b-check>
            <b-form-text 
              class="my-2"
            >
              De volgende items moeten apart worden nagelopen
            </b-form-text>
            <b-list-group>
              <b-list-group-item
                v-for="(item, index) in checklist"
                :key="index"
                :variant="item.item.check ? 'secondary' : 'warning'"
                button
                @click="item.onderdeel._showDetails = true"
              >
                <h6>
                  <b-check
                    v-model="item.item.check"
                    @change="
                      item.item.check
                        ? null
                        : (item.onderdeel._showDetails = false)
                    "
                  >
                    {{ item.onderdeel.title }}
                  </b-check>
                </h6>
                <template v-if="!item.item.check">
                  <component
                    :is="'checklist-item-' + comp"
                    v-for="(comp, index) in item.item.opties"
                    :key="index"
                    :item="item.item"
                    :onderdeel="item.onderdeel"
                    class="my-2"
                  >
                    {{ item.onderdeel.titel }}
                  </component>
                </template>
                <span
                  v-else
                  :style="item.item.check ? 'text-decoration:line-through' : ''"
                >{{ item.item.toelichting }}</span>
              </b-list-group-item>
              <b-list-group-item v-if="checklist.length > 0">
                <b-button
                  :disabled="nogTeChecken.length > 0"
                  class="my-2"
                  size="lg"
                  block
                  variant="danger"
                  @click="deleteChecklist"
                >
                  <i class="fa fa-trash" />
                  Checklist verwijderen
                </b-button>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab title="Technische data info">
            <b-textarea 
              v-model="inventarisatie.TDI" 
              rows="15"
            />
            <b-button
              :disabled="isBusy"
              class="mt-2"
              variant="success"
              @click="opslaanInventarisatie(inventarisatie)"
            >
              <i 
                v-if="!isBusy" 
                class="fa fa-save mx-1"
              />
              <b-spinner
                v-else
                :small="true"
                size="sm"
                class="mx-1"
                role="status"
                variant="secondary"
              />Opslaan Technische data info
            </b-button>
            <br>
            <small>{{ boodschap }}</small>
          </b-tab>

          <b-tab 
            v-if="false" 
            title="Magneten"
          >
            <b-list-group>
              <b-list-group-item
                :is="mod.type"
                v-for="(mod, index) in inspectie.inspectie.moderators"
                :key="index"
                :mod="mod"
              />
            </b-list-group>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col :md="showTechnischeDataInfo ? 9 : 12">
        <matrix
          :config="inspectie.inspectie.config"
          :mods="inspectie.inspectie.moderators"
          :onderdelen="inspectie.inspectie.onderdelen"
          :transpose="transpose"
          :header-rows="[
            {
              label: 'Preventief',
              standaard: getPost('standaardPreventief'),
            },
            {
              label: 'Correctief',
              standaard: getPost('standaardCorrectief'),
            },
            {
              label: 'Overig',
              standaard: overigeKosten,
            },
          ]"
          :fotoboek="fotos"
          :bouwjaar="
            Number(inspectie.inspectie.config.bouwjaar) || Number(unit.Bouwjaar)
          "
          :elementen="elementen"
          :inventarisatie="inventarisatie"
          @transpose-completed="transpose.execute = false"
        />

        <b-form-checkbox 
          v-model="toonResultaat"
        >
          Toon resultaat
        </b-form-checkbox>

        <matrix-resultaat
          v-show="toonResultaat"
          ref="resultaatMatrix"
          :mods="inspectie.inspectie.moderators"
          :config="{
            ...inspectie.inspectie.config,
            jaren: 80,
            jaar: new Date().getUTCFullYear() - 5,
          }"
          :conditie-standaarden="[
            getPost('standaardConditieVervanging'),
            getPost('standaardConditieRevisie'),
          ]"
          :bouwjaar="
            Number(inspectie.inspectie.config.bouwjaar) || Number(unit.Bouwjaar)
          "
          :onderdelen="inspectie.inspectie.onderdelen"
          :inventarisatie="inventarisatie"
        />
      </b-col>
    </b-row>
    <small>{{ prognoseUrl }}</small>
    <b-modal 
      v-model="transpose.showDialog"
      title="Verschuif uitvoeringen bedragen" 
      @ok="transpose.execute = true"
    >
      <b-form-group>
        <b-input-group>
          <b-input 
            v-model.number="transpose.start"
            type="number"
          />
          <b-input-group-text>
            <font-awesome-icon icon="arrow-right" />
          </b-input-group-text>
          <b-input 
            v-model.number="transpose.doel"
            type="number"
          />
          <b-input-group-append is-text>
            <b-checkbox
              v-model="transpose.create"
            >
              aanmaken mits geen bedrag
            </b-checkbox>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import matrix from "@/views/prognoses/Matrix";
import matrixResultaat from "@/views/prognoses/ResultaatMatrix";
import moderatorMagnet from "@/views/prognoses/ModeratorMagnet";
import { elementenMixin } from "@/mixins/elementenMixin";
import ConditieLimit from "../../components/ConditieLimit.vue";
import PrognoseHeader from "../../components/PrognoseHeader.vue";

import "v-calendar/lib/v-calendar.min.css";

import ChecklistItemA from "@/components/checklistitems/ChecklistItemA";
import ChecklistItemB from "@/components/checklistitems/ChecklistItemB";
import ChecklistItemD from "@/components/checklistitems/ChecklistItemD";
import ChecklistItemE from "@/components/checklistitems/ChecklistItemE";
import OpslaanDialog from "@/views/prognoses/OpslaanDialog";

export default {
  name: "PrognoseTab",
  components: {
    OpslaanDialog,
    ChecklistItemA,
    ChecklistItemB,
    ChecklistItemD,
    ChecklistItemE,
    ConditieLimit,
    PrognoseHeader,
    magnet: moderatorMagnet,
    Matrix: matrix,
    MatrixResultaat: matrixResultaat,
  },
  mixins: [serviceMixin, elementenMixin],
  props: {
    unit: { type: Object, default: () => null },
    prognoseid: { type: String, default: null },
  },
  data() {
    return {
      jarenOpties: [5, 10, 15, 20],
      modi: ["Detail", "Positie"],
      inspecteurs: null,
      boodschap: "...",
      prognose: null,
      dismissCountDown: 0,
      isBusy: false,
      transpose: {
        showDialog: false,
        start: 2023,
        doel: 2025,
        create: false,
        execute: false
      },
      toonResultaat: false,
      inspectie: {
        omschrijving: "Ophalen...",
        datum: null,
        inspectie: {
          onderdelen: [],
          mods: [],
          config: {
            showModeratorPanel: false,
          },
        },
        inspecteur: null,
      },
      fotos: [],
      skipChecklist: true,
      showTechnischeDataInfo: false,
      prefixUrl: "/fotos/data/" + this.$props.unit.Id + "/img",
      resultaat: {},
    };
  },
  computed: {
    maxConditieValue: {
  get() {
    // Return null if undefined (for legacy prognoses)
    return this.inspectie.inspectie.config.maxConditie || null;
  },
  set(value) {
    // Set the value, creating the property if it doesn't exist
    this.$set(this.inspectie.inspectie.config, 'maxConditie', value);
  }
},
    conditieLimitOptions() {
      return [
        { value: null, text: 'Geen limiet' },
        { value: 3, text: 'Maximaal 3 (Geel)' },
        { value: 4, text: 'Maximaal 4 (Oranje)' },
        { value: 5, text: 'Maximaal 5 (Rood)' }
      ];
    },
    overigeKosten: function () {
      return (
        this.getPost("standaardKeuringskosten") +
        this.getPost("standaardAdvieskosten") +
        this.getPost("standaardSpreekluister")
      );
    },
    nogTeChecken: function () {
      return this.checklist.filter((item) => !item.item.check);
    },
    importlijst: function () {
      var imports = [];

      (this.inspectie.inspectie.onderdelen || []).forEach((element) =>
        element.children.forEach((onderdeel) => {
          var hasNoChecklist =
            !onderdeel.checklist ||
            (onderdeel.checklist.opties || []).length == 0;
          if (onderdeel.import && (!this.skipChecklist || hasNoChecklist))
            imports.push(onderdeel);
        })
      );
      return imports;
    },
    checklist: function () {
      var items = [];
      (this.inspectie.inspectie.onderdelen || []).forEach((element) => {
    
        if (element.checklist) items.concat(...element.checklist);
        (element.children || []).forEach((onderdeel) => {
          if (onderdeel.checklist)
            items.push({ item: onderdeel.checklist, onderdeel: onderdeel });
          console.log("- ", onderdeel.title, " items ");
        });
      });
      return items;
    },
    prognoseUrl: function () {
      return (
        "/unit/" + this.$props.unit.Id + "/inspectie/" + this.$props.prognoseid
      );
    },
  },
  watch: {
    prognoseid: function (oldVal, newVal) {
      if (oldVal != newVal) this.reloadPrognose();
    },
  },
  mounted() {
    this.loadElementen();
    this.reloadPrognose();
  },
  methods: {
    acties(onderdeel) {
      return this.getImportOnderdeel(onderdeel).onderdelen || [];
    },
    reloadPrognose() {
      this.loadPrognose();
      this.getImportPrognose();
      this.getFotoPrefix();
      this.loadInventarisatie();
    },
    getImportOnderdeel(onderdeel) {
      var importOnderdeel = {};
      if (this.prognose) {
        this.prognose.onderdelen.forEach((elem) =>
          elem.onderdelen.forEach(function (o) {
            if (o.legacyId == "onderdeel_" + onderdeel.import)
              importOnderdeel = o;
          })
        );
      }
      return importOnderdeel;
    },
    importOptions(onderdeel) {
      return {
        filter: onderdeel.import,
        prognosestartjaar: this.prognose.jaar,
        items: this.acties(onderdeel),
      };
    },
    transposeExecute() {
      console.log(this.transpose);
    },
    getImportPrognose() {
      var vm = this;
      this.get("/unit/" + this.$props.unit.Id + "/prognose")
        .then(function (response) {
          vm.prognose = response.data.imports;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deleteChecklist() {
      this.inspectie.inspectie.onderdelen.forEach((element) => {
        console.log(element.title);
        if (element.checklist) element.checklist = null;
        element.children.forEach((onderdeel) => {
          if (onderdeel.checklist) onderdeel.checklist = null;
        });
      });
    },
    startImport() {
      // voor alle onderdelen het bedrage en de jaren overnemen van de oude prognose.
      console.log("start auto import");
      this.importlijst.forEach((onderdeel) => {
        console.log("import voor", onderdeel.title);
        onderdeel.acties.forEach((actie, index) => {
          console.log("actie", index, this.acties(onderdeel)[index]);
          var importItem = this.acties(onderdeel)[index];
          if (importItem) {
            actie.werkzaamheden = importItem.omschrijving;
            if (!actie.bedraglocked) {
              actie.bedrag =
                importItem.resultaat[
                  importItem.eersteJaar -
                    this.importOptions(onderdeel).prognosestartjaar
                ];
            }
            actie.jaar = importItem.eersteJaar - actie.cyclus;
            actie.omschrijving =
              this.getImportOnderdeel(onderdeel).huidigeConditie.opmerking;
          }
        });
      });
    },
    isUnitKey(key) {
      return Number(this.unit.Instellingen[key]) > 0;
    },
    getPost(key) {
      if (this.unit.Instellingen[key] !== "")
        return Math.round(this.unit.Instellingen[key]);
      if (Number.isInteger(this.unit.Complex.Relatie.Config[key]))
        return this.unit.Complex.Relatie.Config[key];
      return 0;
    },

    getFotoPrefix() {
      var vm = this;
      this.$http
        .get(this.prefixUrl, {
          headers: {
            token: vm.$store.state.token,
          },
        })
        .then(function (response) {
          console.dir(response.data);
          vm.fotos = response.data.fotos;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    warningHuidigePrognose() {
      alert("Deze prognose kan niet verwijderd worden!");
    },
    ladenElementen() {
      this.get("/elementen/presets")
        .then(function (response) {
          console.dir(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadPrognose() {
      var vm = this;
      this.get(this.prognoseUrl)
        .then(function (response) {
          console.dir(response.data);
          vm.inspectie = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    createPrognose() {
      var vm = this;
      var kopietitel = "KOPIE " + this.inspectie.omschrijving.toString();
      this.post("/unit/" + this.$props.unit.Id + "/inspecties", {
        inspectiedata: this.inspectie.inspectie,
        omschrijving: kopietitel,
      })
        .then(function (response) {
          console.dir(response.data);
          vm.unit.Prognoses.push(response.data.inspectie);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updatePrognose(checklistAction) {
      console.log(checklistAction)
      this.$set(this.inspectie.inspectie.config, 'inclusief', 0);
      var vm = this;
      this.put(this.prognoseUrl, {
        inspectiedata: this.inspectie.inspectie,
        omschrijving: this.inspectie.omschrijving,
        isTemplate: this.inspectie.isTemplate,
        isBevroren: this.inspectie.isBevroren,
        uren: this.inspectie.uren,
        gereed: this.inspectie.gereed,
        datum: this.inspectie.datum,
        resultaat: this.$refs.resultaatMatrix.resultaat,
        inspecteur: this.inspectie.inspecteur,
        checklistaction: checklistAction,
      })
        .then(function (response) {
          console.dir(response.data);
          for (var p in vm.unit.Prognoses) {
            if (vm.unit.Prognoses[p].Id == vm.prognoseid) {
              vm.unit.Prognoses[p] = response.data.inspectie;
            }
            vm.dismissCountDown = 2;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deletePrognose() {
      var vm = this;
      this.delete(this.prognoseUrl)
        .then(function (response) {
          console.dir(response.data);
          for (var p in vm.unit.Prognoses) {
            if (vm.unit.Prognoses[p].Id == vm.prognoseid) {
              vm.unit.Prognoses.splice(p, 1);
              vm.$router.push({ name: "Prognoses" });
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
  },
};
</script>